import { ErrorHandler } from '@angular/core';
import { BaseService } from '../services/base/base-service';

export class CustomErrorHandler implements ErrorHandler {
  //  constructor(public snackbarService: BaseService<any>) { }
  handleError(_error: any) { 
    // do something with the exception
    //this.snackbarService.showMessage(_error, 'X');
    
    console.log(_error);
  }
}
